export default __webpack_public_path__ + "static/media/louisville_texture.ec57fbee.jpg";